import {Helmet} from 'react-helmet-async';

import ForeCastComponent from '../app-rationalization/ARForecast/ARForecastComponent';

const Forecast = () => (
  <>
    <Helmet>
      <title> Dashboard: Forecast</title>
    </Helmet>

    <ForeCastComponent />
  </>
);

export default Forecast;
